import React, { memo } from 'react';
import { Outlet } from "react-router";
import FooterWithLinks from './footers/FooterWithLinks';
import NavbarHomeLanding from './navbars/NavbarHomeLanding';
import { useLayout } from '../../redux/ducks/layout';
import NavbarMegaMenu from './navbars/mega-menu/NavbarMegaMenu';

const ProductLandingLayout = () => {
    //#region useLayout

    const { pageProps } = useLayout();

    //#endregion
    //#region useStates

    const [paddingTop, setPaddingTop] = React.useState(0);
    const [paddingBottom, setPaddingBottom] = React.useState(0);

    //#endregion
    //#region headerProps

    const headerProps = {
        nav: {
            classes: pageProps?.nav && pageProps?.nav?.classes,
            fixed: pageProps?.nav && pageProps?.nav?.fixed,
            color: pageProps?.nav && pageProps?.nav?.color,
            light: pageProps?.nav && pageProps?.nav?.light,
            dark: pageProps?.nav && pageProps?.nav?.dark,
            sticky: pageProps?.nav && pageProps?.nav?.sticky,
        },
        loggedUser: pageProps?.loggedUser,
        headerClasses: pageProps?.headerClasses,
        headerAbsolute: pageProps?.headerAbsolute,
        hideTopbar: pageProps?.hideTopbar,
        setPaddingTop: (event) => setPaddingTop(event),
        setPaddingBottom: (event) => setPaddingBottom(event),
        topbarContent: pageProps?.topbarContent,
        topbarBgVariant: pageProps?.topbarBgVariant ?? null,
        topbarTextVariant: pageProps?.topbarTextVariant ?? null,
        navCTA: pageProps?.navCTA ?? null,
        floatingCTA: pageProps?.floatingCTA ?? null
    };

    //#endregion

    return (
        <div style={{ paddingTop: pageProps?.noPaddingTop ? "0" : paddingTop }} className={pageProps.className}>
            {!pageProps?.hideHeader && <NavbarHomeLanding {...headerProps} />}
            {/* <NavbarMegaMenu /> */}
            {/* <div style={{ height: pageProps?.mainTopHeight ?? '70px' }} id="main-top" className='main-top'></div> */}

            {/* <NotificationBar /> */}

            <Outlet />

            {!pageProps.hideFooter &&
                <div style={{ paddingBottom: pageProps?.noPaddingBottom ? "0" : paddingBottom, background: '#121212' }}>
                    <FooterWithLinks />
                </div>
            }
        </div>
    );
};

export default memo(ProductLandingLayout);